<template>
  <div class="file-transform-wrapper">
    <EmbeddedApp
      :token="token"
      :lang="lang"
      :api-base-url="apiBaseUrl"
    />
  </div>
</template>

<script>
import EmbeddedApp from '@vue-file-transform/EmbeddedApp.vue'
import Configuration from '@/configuration'

export default {
  name: 'file-transform',
  components: { EmbeddedApp },
  props: ['content', 'type', 'apiDefinitionId', 'id'],
  data () {
    return { _tokenTick: 0 }
  },
  computed: {
    token () {
      // eslint-disable-next-line no-unused-expressions
      this._tokenTick // dependència reactiva per forçar re-lectura del token
      return window.localStorage.getItem('user-token') || ''
    },
    lang () {
      return this.$ml ? this.$ml.current : 'ca'
    },
    apiBaseUrl () {
      return Configuration.value('API_SERVICES_URL') || ''
    }
  },
  mounted () {
    this.$emit('definitionLoaded')
    this._tokenTick++
  }
}
</script>

<style scoped>
.file-transform-wrapper {
  overflow: auto;
  height: 100%;
  min-height: 600px;
}
</style>
